 vehicleFormValidator = () => {
  processVehicleForm();

  function processForm(event) {
    event.preventDefault();
    event.stopPropagation();
    
    // Disable the clicked button to prevent double-clicks
    let clickedButton = $(event.target);
    clickedButton.prop('disabled', true);
    
    showLoader();
    let currentForm = $(`#${event.target.dataset.targetForm}`);

    if (currentForm.length !== 0) {
      // Validate required fields in current section
      let validationResult = validateRequiredFields(currentForm);
      if (!validationResult.isValid) {
        // Focus on the first error field
        if (validationResult.firstErrorField) {
          validationResult.firstErrorField.focus();
        }

        hideLoader();
        // Re-enable the button if validation fails
        clickedButton.prop('disabled', false);
        return;
      }
    }
    submitForm($(event.target).data("target-form"));
    hideLoader();
  }

  function processVehicleForm() {
    $(document).off('click', '.new-vehicle-btn').on('click', '.new-vehicle-btn', function (e) {
      processForm(e);
    });

    // Add real-time validation for required fields
    $(document).on('blur', '.requiredField', function() {
      validateSingleField($(this));
    });

    // Add real-time validation for select fields
    $(document).on('change', '.requiredField', function() {
      validateSingleField($(this));
    });
  }

  function validateRequiredFields(section) {
    let isValid = true;
    let firstErrorField = null;
    
    // Clear previous error states
    section.find('.requiredField').removeClass('is-invalid').removeClass('error-field');
    section.find('.error-message').remove();
    
    section.find('.requiredField').each(function() {
      let field = $(this);
      let fieldValue = field.val();
      let fieldType = field.attr('type');
      
      let isFieldValid = true;
      
      if (fieldType === 'file') {
        if (!validFileField(field)) {
          isFieldValid = false;
        }
      } else if (fieldType === 'checkbox' || fieldType === 'radio') {
        if (!field.is(':checked')) {
          isFieldValid = false;
        }
      } else {
        if (fieldValue.length === 0 || fieldValue.trim() === '') {
          isFieldValid = false;
        }
      }
      
      if (!isFieldValid) {
        isValid = false;
        if (!firstErrorField) {
          firstErrorField = field;
        }
        
        // Add error message below the field
        let errorMessage = field.attr('data-error-message') || '';
        let errorElement = $('<div class="error-message text-danger small mt-1">' + errorMessage + '</div>');

        // skip adding errorElement if required input is radio
        // separately handle for radio group
        if(field.prop('tagName') === 'INPUT' && field.prop('type') === 'radio') {
          let radioBtnGroup = field.closest('[data-radio-group]');
          let hasValidInput = radioBtnGroup.find('.requiredField').is(':checked');

          if(!hasValidInput) {
            field.addClass('is-invalid').addClass('error-field');
          }
          return true;
        } else if (fieldType === 'file') {
          if (!validFileField(field)) {
            let uploadForm = field.closest('div.upload-form.file-upload-area');
            uploadForm.addClass('is-invalid error-field');
            uploadForm.after(errorElement);
          }
        } else {
          // Add error styling and message
          field.addClass('is-invalid').addClass('error-field');

          // For inputs using select2
          if(field.prop('tagName') === 'SELECT' && field.is('[data-select2-id]')) {
            // mark select2 span as invalid
            field.parent().find('.select2-selection--single').addClass('error-field');
            field.parent().append(errorElement);
          } else if (field.parent().hasClass('input-wrapper')) {
            field.parent().after(errorElement);
          } else {
            field.after(errorElement);
          }
        }
      }
    });

    // Validate atleast one vehicle service presence
    if(section.attr('id') === 'new-vehicle-maintenance-form' || section.attr('id') === 'edit-vehicle-maintenance-form') {
      if(section.find('.nested-fields.vehicle-service:visible').length === 0) {
        section.find('#vehicle-service-error-message').append('<div class="error-message text-danger small mb-3">Please add atleast one maintenance type.</div>');
        isValid =  false;
      }
    }

    return {
      isValid: isValid,
      firstErrorField: firstErrorField
    };
  }

  function validateSingleField(field) {
    let fieldValue = field.val();
    let fieldType = field.attr('type');
    
    // Remove previous error state
    // handle separately for radio button group & file input
    if(fieldType !== 'radio' && fieldType !== 'file') {
      field.removeClass('is-invalid').removeClass('error-field');

      // for fields with prefix or trailing icon/unit
      if(field.parent().hasClass('input-wrapper')) {
        field.parent().siblings('.error-message').remove();
      } else {
        field.siblings('.error-message').remove();
      }
    }
    
    let isValid = true;
    
    if (fieldType === 'file') {
      if (validFileField(field)) {
        let uploadForm = field.closest('div[data-handlers-initialized]');
        uploadForm.removeClass('is-invalid error-field');
        uploadForm.siblings('.error-message').remove();
      } else {
        isValid = false;
      }
    } else if (fieldType === 'checkbox' || fieldType === 'radio') {
      if(fieldType === 'radio') {
        let radioBtnGroup = field.closest('[data-radio-group]');
        if(radioBtnGroup.find('.requiredField').is(':checked')) {
          radioBtnGroup.find('.requiredField').removeClass('requiredField').removeClass('is-invalid').removeClass('error-field');
        } else {
          isValid = false;
        }
      } else {
        if (!field.is(':checked')) {
          isValid = false;
        }
      }
      return true;
    } else if (field[0].tagName === 'SELECT') {
      if (field[0].value.length === 0) {
        isFieldValid = false;
      }
    } else {
      if (fieldValue.length === 0 || fieldValue.trim() === '') {
        isValid = false;
      }
    }
    
    if (!isValid) {
      // Add error styling and message
      field.addClass('is-invalid').addClass('error-field');
      
      // Add error message below the field
      let errorMessage = field.attr('data-error-message') || '';
      let errorElement = $('<div class="error-message text-danger small mt-1">' + errorMessage + '</div>');

      if(field.parent().hasClass('input-wrapper')) {
        field.parent().after(errorElement);
      } else {
        field.after(errorElement);
      }
    }
  }

  function validFileField(fileField) {
    let uploadFormConatiner = fileField.closest('div[data-target=upload-form]');
    let filePreviewDom = uploadFormConatiner.find('div[data-preview]');

    return filePreviewDom.find('div.file-preview').length > 0;
  }

  function submitForm(targetId) {
    let form = $(`#${targetId}`)[0];
    form.requestSubmit();
  }
}

document.addEventListener('turbolinks:load', function () {
  if ($('.vehicles, .vehicle_maintenances, .vehicle_incidents, .vehicle_mileages').length === 0) {
    return;
  }
  vehicleFormValidator();
});

function showLoader() {
  $('.loading-spinner').css('z-index', 2000);
  $('.loading-spinner').show();
  $('body').css({
    pointerEvents: "none"
  })
}

function hideLoader() {
  $('.loading-spinner').hide();
  $('body').css({
    pointerEvents: "auto"
  });
}
